// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XxMh","right":"styles_right__2sljn"};